import { effect, inject } from '@angular/core';
import { StandardProductDetailsComponentStore } from 'products-data';
import { ItemComponentBase } from 'products-ui';
import { CartItemResultRenderTarget, CartItemResultRenderTargetComponents } from '../cart-item/cart-item-result-layout/render-targets';

export abstract class SavedPartListItemResultLayoutComponentsProviderComponentBase extends ItemComponentBase {
  protected readonly LayoutTargets = CartItemResultRenderTarget;
  protected readonly LayoutComponents = CartItemResultRenderTargetComponents;
  protected readonly productDetailStore = inject(StandardProductDetailsComponentStore);

  constructor() {
    super();
    effect(() => {
      this.productDetailStore.selectById(this.productId());
    });
  }
}
